import React from 'react'
import Header from "../Home/Header"
import Image from './Image'

const Gallery = () => {
  return (
    <>
      <Image />
    </>
  )
}

export default Gallery